import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CostharegionListService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	constructor(private http: Http) { }

	listCost(token) {
		return this.http
		.get(this.apiUrl + "/costharegion/v1/getcostharegion", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	searchCost(token, estado, cidade, status, orderby, sort, page) {

		page = page * globalConst.paginationSkip;

		var estadoFilter ="";
		if (estado != "") estadoFilter = " and Cidade/EstadoID eq guid'" + estado + "'";

		var cidadeFilter ="";
		if (cidade != "") cidadeFilter = " and CidadeID eq guid'" + cidade + "'";

		var statusFilter = "";
		if (status != "") statusFilter = " and Ativo eq " + status;

		return this.http
		.get(this.apiUrl + "/costharegion/v1/getcostharegion/?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=1 eq 1" + estadoFilter + cidadeFilter + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});


	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/service/costharegion-list/costharegion-list.service.ts